import { type Images } from '@neos/app'
import downloadPath from '../../modules/TmsCoreAnomInvoices/images/Download.svg'
import selectAllPath from '../../modules/TmsCoreAnomInvoices/images/SelectAll.svg'
import tmsCoreAkaneaPath from '../../modules/TmsCoreAnomCore/images/TmsCoreAkanea.svg'
import unselectAllPath from '../../modules/TmsCoreAnomInvoices/images/UnselectAll.svg'
import visualizePath from '../../modules/TmsCoreAnomInvoices/images/Visualize.svg'
import visualizeBlockedPath from '../../modules/TmsCoreAnomInvoices/images/VisualizeBlocked.svg'

const images: Images = {
  download: { path: downloadPath, colored: false },
  selectAll: { path: selectAllPath, colored: false },
  tmsCoreAkanea: { path: tmsCoreAkaneaPath, colored: false },
  unselectAll: { path: unselectAllPath, colored: false },
  visualize: { path: visualizePath, colored: false },
  visualizeBlocked: { path: visualizeBlockedPath, colored: false },
}

export default images